import React from 'react';
import LockIcon from '@mui/icons-material/Lock';

import clsx from 'clsx';
import { IconButton, IconButtonProps, Tooltip } from '@mui/material';
import { useI18n } from 'AurionCR/components';

interface Classes {
  root: string;
}

interface Props extends IconButtonProps {
  iconFontSize?: 'small' | 'inherit' | 'medium' | 'large' | 'medium';
  className?: string;
  classes?: Partial<Classes>;
}

export const MeetingLock: React.FC<React.PropsWithChildren<Props>> = ({
  className,
  classes,
  iconFontSize = 'medium',
  ...rest
}) => {
  const { t } = useI18n();
  return (
    <Tooltip title={t('meeting-lock')} placement={'top'}>
      <IconButton className={clsx(classes?.root, className)} color={'secondary'} {...rest}>
        <LockIcon fontSize={iconFontSize} />
      </IconButton>
    </Tooltip>
  );
};
